module.exports = [{
      plugin: require('/Users/fabio/Documents/projects/training-website-2019/training-website/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
